module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/key-dfbe2bde933ce09d4047feada799bffb.svg";